import React, { useState } from "react";
import { Card, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ADD_FUNDS_TO_USD_BALANCE_ROUTE } from "../../utils/consts";
import {getAvailableSellVirtOrdersApi, buySellVirtOrderApi, check} from "../../http/userAPI";
import { Context } from "../../index";
import { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const BuyVirtOnStock = ({ refreshKey = 0 }) => {
    const navigate = useNavigate();
    const [buying, setBuying] = useState(false);
    const { user } = useContext(Context);

// баланс в USD из данных юзера
    const usdBalance = Number(user?.user?.lr_balance ?? 0);
    // для кнопки Refresh
    const [refreshing, setRefreshing] = useState(false);

// заявки с бэка
    const [orders, setOrders] = useState([]);
    const [ordersCount, setOrdersCount] = useState(0);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const loadOrders = async () => {
        try {
            setLoadingOrders(true);
            const data = await getAvailableSellVirtOrdersApi({ limit: 30, offset: 0 });
            setOrders(data?.rows ?? []);
            setOrdersCount(Number(data?.count ?? 0));
        } catch (e) {
            console.error("Failed to fetch available orders", e);
        } finally {
            setLoadingOrders(false);
        }
    };

    useEffect(() => {
        loadOrders();
    }, [refreshKey]);

    const handleConfirmBuy = async () => {
        if (!selectedOrder || !user?.user?.id) return;
        try {
            setBuying(true);
            const res = await buySellVirtOrderApi({
                orderId: selectedOrder.id,
                userId: user.user.id,
                comment: "Bought from frontend",
            });

            toast.success(res?.message || `Order #${selectedOrder.id} purchased`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            closeBuyModal();
            await loadOrders();          // обновить карточки
            try {
                const fresh = await check(); // подтянуть свежий баланс (USD/Virt)
                user.setUser(fresh);
            } catch {}
        } catch (e) {
            const msg = e?.response?.data?.message || "Failed to buy order";
            toast.error(msg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setBuying(false);
        }
    };

    const refreshOrders = async () => {
        try {
            setRefreshing(true);
            await loadOrders();
            // Опционально подтянуть баланс пользователя:
            const fresh = await check();
            user.setUser(fresh);
        } finally {
            setRefreshing(false);
        }
    };

    // для модалки покупки
    const [showBuy, setShowBuy] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const openBuyModal = (order) => {
        setSelectedOrder(order);
        setShowBuy(true);
    };

    const closeBuyModal = () => {
        setSelectedOrder(null);
        setShowBuy(false);
    };

    return (
        <Card className="p-3 w-100 mt-0">
            <div className="d-flex flex-column flex-md-row flex-md-nowrap justify-content-between align-items-start align-items-md-center gap-2">
                <h5 className="text-muted mb-2 mb-md-0 me-md-3 text-nowrap">
                    Buy Virt on the Exchange
                </h5>

                <div className="d-flex w-100 justify-content-between gap-2 w-md-auto justify-content-md-end ms-md-auto">
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={refreshOrders}
                        disabled={loadingOrders || refreshing}
                        title="Refresh Data"
                    >
                        {refreshing ? (
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : null}
                        Refresh Data
                    </Button>

                    <Button
                        size="sm"
                        variant="outline-success"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE)}
                    >
                        Add Funds
                    </Button>
                </div>
            </div>
            <div className="text-muted small mt-2">
              <span className="text-muted d-block mb-1">
                  Here you can buy Virt from other users’ sell orders. Click any card to see the
                  rate and confirm the purchase. Once confirmed, the price in <strong>USD</strong> will be
                  deducted from your balance and the purchased <strong>Virt</strong> will be credited instantly.
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center text-muted mt-1">
                      <div className="flex-grow-1 me-0 me-md-3 mb-0 mb-md-0">
                          <strong className="text-danger">Note:</strong> Prices are set by sellers and filled
                          on a first-come, first-served basis. Make sure you have enough USD balance — you can
                          top it up via <em>Add Funds to USD Balance</em>.
                      </div>
                  </div>
              </span>
            </div>
                <div className="row g-3 mt-0">
                    {loadingOrders ? (
                        <p className="text-muted text-center">Loading orders…</p>
                    ) : orders.length === 0 ? (
                        <p className="text-muted text-center">No available sell orders</p>
                    ) : (
                        orders.map((order) => (
                            <div key={order.id} className="col-12 col-md-4 ">
                                {/* Desktop card */}
                                <Card
                                    className="h-100 border border-secondary shadow-sm d-none d-md-block"
                                    style={{
                                        transition: "all 0.2s ease-in-out",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => openBuyModal(order)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.03)";
                                        e.currentTarget.style.boxShadow = "0 0 12px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 0 5px rgba(0,0,0,0.05)";
                                    }}
                                >
                                    <Card.Body className="d-flex flex-column justify-content-between ms-0 py-2">
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <strong className="text-success fw-semibold mb-0">
                                                    Order: #{order.id}
                                                </strong>

                                                <span className="text-muted fw-semibold">
          {order.virt_amount.toLocaleString()} Virt{" "}
                                                    <i className="fas fa-exchange-alt text-success ms-2 me-2"></i>${Number(order.usd_amount).toFixed(2)}
        </span>
                                            </div>

                                            <div className="mt-2 text-muted small">
                                                {/* USD -> Virt */}
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <div className="d-flex fst-italic fs-6 fw-semibold align-items-center">
                                                        <i className="fas fa-coins text-danger me-2"></i>
                                                        <span>Rate $ → Virt:</span>
                                                    </div>
                                                    <span className="border border-secondary rounded px-2 py-1">
            <strong>$1</strong> ={" "}
                                                        <strong>{Number(order.price_virt_per_usd).toFixed(2)} Virt</strong>
          </span>
                                                </div>

                                                {/* Virt -> USD */}
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <div className="d-flex fst-italic text-muted fs-6 fw-semibold align-items-center">
                                                        <i className="fas fa-coins text-warning me-2"></i>
                                                        <span>Rate Virt → $:</span>
                                                    </div>
                                                    <span className="border border-secondary rounded px-2 py-1">
            1000 Virt ≈ <strong>${Number(order.price_usd_per_1000_virt).toFixed(2)}</strong>
          </span>
                                                </div>

                                                {/* Order summary */}
                                                <div className="d-flex align-items-center mt-2">
                                                    <h6 className="text-success fw-semibold mb-0">
                                                        <i className="fas fa-shopping-cart text-success me-2"></i>
                                                        <span>
              Order Now: {order.virt_amount.toLocaleString()} Virt for $
                                                            {Number(order.usd_amount).toFixed(2)}
            </span>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                {/* Mobile card (compact) */}
                                <Card
                                    className="h-100 border border-secondary shadow-sm d-block d-md-none"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => openBuyModal(order)}
                                >
                                    <Card.Body className="py-2">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-success fw-bold small">#{order.id}</span>
                                            <span className="text-muted fw-semibold small">
        {order.virt_amount.toLocaleString()} Virt for ${Number(order.usd_amount).toFixed(2)}
      </span>
                                        </div>
                                        <div className="mt-1 text-muted small">
                                            <div>
                                                <i className="fas fa-coins text-warning me-2"></i>
                                               $1 → {Number(order.price_virt_per_usd).toFixed(2)} V | 1000 V ≈ ${Number(order.price_usd_per_1000_virt).toFixed(2)}
                                            </div>
                                        </div>
                                        <div className="mt-1 text-success small">
                                            <i className="fas fa-shopping-cart me-2"></i>
                                            Buy Now: {order.virt_amount.toLocaleString()} Virt for ${Number(order.usd_amount).toFixed(2)}
                                        </div>
                                    </Card.Body>
                                </Card>

                            </div>
                        ))
                    )}
                </div>




            {/* Модалка покупки */}
            <Modal show={showBuy} onHide={closeBuyModal} top>
                <Modal.Header closeButton style={{ height: 40 }}>
                    <Modal.Title className="fs-6">Confirm Purchase Lott #{selectedOrder?.id} </Modal.Title>
                </Modal.Header>

                <Modal.Body className="small">
                    {selectedOrder && (
                        <>
                            <div className="mb-2 text-center">
                                <h6 className="text-muted mb-0">
                                    You are about to buy{" "}
                                    <strong>{Number(selectedOrder.virt_amount).toLocaleString()} Virt</strong>{" "}
                                    for <strong>${Number(selectedOrder.usd_amount).toFixed(2)}</strong>.
                                </h6>

                                <h6 className="text-muted mt-1 mb-0">
                                    1 USD = {Number(selectedOrder.price_virt_per_usd).toFixed(2)} Virt &nbsp; | &nbsp;
                                    1000 Virt ≈ ${(1000 / Number(selectedOrder.price_virt_per_usd)).toFixed(2)}
                                </h6>
                            </div>

                            <hr />

                            {(() => {
                                const afterPurchase = (Number(usdBalance) - Number(selectedOrder.usd_amount));
                                return (
                                    <>
                                        <h6 className="mb-0 text-success">
                                            Your current USD balance: <strong>${Number(usdBalance).toFixed(2)}</strong>
                                        </h6>
                                        <h6 className="mb-1  text-success">
                                            After purchase: <strong>${afterPurchase.toFixed(2)}</strong>
                                        </h6>
                                    </>
                                );
                            })()}
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between" style={{ height: 60 }}>
                    <Button variant="outline-secondary" size="sm" onClick={closeBuyModal}>
                        Cancel
                    </Button>
                    {selectedOrder && Number(usdBalance) < Number(selectedOrder.usd_amount) ? (
                        <Button
                            variant="warning"
                            size="sm"
                            onClick={() => navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE)}
                        >
                            Add Funds to USD Balance
                        </Button>
                    ) : (
                        <Button
                            variant="success"
                            size="sm"
                            onClick={handleConfirmBuy}
                            disabled={buying}
                        >
                            {buying ? <Spinner animation="border" size="sm" /> : "Confirm Buy"}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

        </Card>
    );
};

export default BuyVirtOnStock;
